/* src/app/modules/display/components/menus/marketing-menu/marketing-combo-menu/marketing-combo-menu.component.scss */
.marketing-combo-menu-wrapper {
  width: 100%;
  height: 100%;
}
.card-grid {
  display: block;
}
/*# sourceMappingURL=marketing-combo-menu.component.css.map */
